import { graphql } from "@/gql/assistant";

export const MeProfile = graphql(`
  query MeProfile {
    me {
      profile {
        id
        givenName
        surname
        email
        userName
        loginProviders {
          provider
          loginProvider
          providerKey
        }
      }
    }
  }
`);